import { lazy } from 'react';
import * as routePath from '../route-path';
import * as routeName from '../route-name';

const Support = lazy(() => import('components/Pages/Support'));


export const supportRoutes = [
  {
    path: routePath.SUPPORT,
    component: Support,
    exact: true,
    showMenu: false,
    name: routeName.SUPPORT,
  },
];
